<template>
  <div class="running-view">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
      <div class="white-container">
        <el-form-item label="报名方式" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio :label="0">跑步</el-radio>
            <el-radio :label="1">骑行</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="活动主标题" prop="name" style="width: 440px">
          <el-input v-model="form.name" placeholder="请输入活动主标题，最多不超过14个字" maxlength="14" :disabled="disabled" />
        </el-form-item>
        <el-form-item label="抽奖形式" prop="isShow" label-width="100px">
          <el-radio-group v-model="form.luckyDrawType" :disabled="disabled">
            <el-radio :label="0">前抽</el-radio>
            <el-radio :label="1">后抽</el-radio>
            <el-radio :label="2">不抽</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item :label="form.type === 0 ? '跑步距离' : '骑行距离' " prop="runningDistance" style="width: 300px">
          <div class="flex">
            <el-input v-model="form.runningDistance" placeholder="输入公里数" style="width:98px;margin-right:5px" :disabled="disabled" type="number" @input="farmatInput" />公里
          </div>
        </el-form-item> -->
        <el-form-item label-width="0" prop="ridingDistance" style="width: 600px" :show-message="false">
          <div v-for="(item, index) in form.ridingDistance" :key="item.id" class="relative flex">
            <div class="flex multi-distance-item relative">
              <div class="multi-distance-label">目标公里数</div>
              <el-input v-model="item.runningDistance" placeholder="输入公里数" style="width:98px;margin-right:5px" :disabled="disabled" type="number" @input="farmatInput(index)" />公里
              <div v-if="item.isError" class="el-form-item__error multi-distance-error">请输入{{ form.type === 0 ? '跑步距离' : '骑行距离' }}</div>
            </div>
            <template v-if="item.prizeInformation">
              <div v-show="form.luckyDrawType === 0" class="flex multi-distance-item relative">
                <div class="multi-distance-label">关联奖池</div>
                <el-select
                  v-model="item.prizeInformation.poolId"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请选择关联奖池"
                  :remote-method="remotePrizeMethod"
                  @input.native="handlePlanInputChange"
                  @change="handlePrizeChange($event,item,index)"
                  @visible-change="handlePrizeInputVisibleChange"
                >
                  <!-- slot empty -->
                  <template #empty>
                    <div class="empty-text">没有查到相关奖池</div>
                  </template>
                  <el-option
                    v-for="ele in poolList"
                    :key="ele.id"
                    :value="ele.id"
                    :label="ele.name"
                  >
                    <span style="float: left">{{ ele.name }}</span>
                    <span style="color: #8492a6; font-size: 13px">(ID:{{ ele.id }})</span>
                  </el-option>
                </el-select>
                <div v-if="item.isErrorSelect" class="el-form-item__error multi-distance-error">请选择关联奖池</div>
              </div>
            </template>

            <div v-if="form.ridingDistance.length>1" class="delete-icon" @click="removeMultiDistance(item.id)">
              <i class="el-icon-delete" />
            </div>
          </div>
          <el-button type="primary" class="add-multi-distance-btn" @click="addMultiDistance">+ 添加目标公里数</el-button>
        </el-form-item>
        <el-form-item label="首页奖品图片" prop="prizePreviewChart" label-width="110px">
          <div class="preview-banner">
            <UploadImage :disabled="disabled" :url="form.prizePreviewChart" save-path="running/" breadth="670px" @triggerReg="handleCheckChartReg" @upload="data => (form.prizePreviewChart = data)" />
          </div>
        </el-form-item>
        <el-form-item label="抽奖页标题" style="width: 440px">
          <el-input v-model="form.sweepstakesPageTitle" placeholder="请输入抽奖页标题" maxlength="10" :disabled="disabled" />
        </el-form-item>
        <el-form-item label="活动时间" prop="exportTime" style="width: 420px">
          <el-date-picker v-model="form.exportTime" type="datetimerange" placeholder="请选择活动日期" prefix-icon="el-icon-date" class="custom-date" start-placeholder="活动开始日期" end-placeholder="活动结束日期" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-form-item label="活动简介" prop="content" style="width: 80%">
          <el-input v-model="form.content" type="textarea" :rows="4" placeholder="请输入活动简介" :disabled="disabled" />
        </el-form-item>
        <!-- <el-form-item label="抽奖规则" prop="sweepstakesRules" style="width: 80%">
          <el-input v-model="form.sweepstakesRules" type="textarea" :rows="4" placeholder="请输入抽奖规则" :disabled="disabled" />
        </el-form-item> -->
        <el-form-item label="注意事项" prop="announcement" style="width: 80%">
          <el-input v-model="form.announcement" type="textarea" :rows="4" placeholder="请输入注意事项" :disabled="disabled" />
        </el-form-item>
        <el-form-item label="社群Banner" prop="communityBanner.linkUrl" style="width: 440px">
          <el-input v-model="form.communityBanner.linkUrl" placeholder="请输入社群Banner跳转链接" :disabled="disabled" />
        </el-form-item>
        <!-- <el-form-item label="奖品配置" prop="prizeInformationAddDTOList">
          <div :class="lottery?'lotteryDisabled':''" title="已开奖后无法修改" style="margin-left:-48px;margin-top:40px;font-family: 'Noto Sans SC'">
            <template v-for="(item, index) in form.prizeInformationAddDTOList">
              <div :key="index" style="margin:20px 0" :class="lottery?'lottery-context':''">
                <span style="margin-right: 10px">奖品{{ index + 1 }}</span>
                <el-input v-model="item.prizeName" placeholder="请输入奖品名称" style="width: 147px;margin:0 10px 0 0" :disabled="disabled" />
                <el-input v-model="item.prizeNum" type="number" placeholder="请输入奖品数量" style="width: 147px;margin:0 10px 0 0" :disabled="disabled" />
                <span class="delPrize" style="font-size: 14px;color: #0085D0;user-select: none;cursor: pointer;" @click="()=>{form.prizeInformationAddDTOList.splice(index, 1)}">删除</span>
              </div>
            </template>
          </div>
          <el-button v-if="!lottery" class="addPrize" @click="addPrizeItem">+ 新增奖品</el-button>
        </el-form-item> -->
        <el-form-item label="是否在列表页展示" prop="isShow" label-width="140px">
          <el-radio-group v-model="form.isShow" :disabled="disabled">
            <el-radio :label="0">是</el-radio>
            <el-radio :label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="white-container marginTop">
        <el-form-item label="活动课程推荐配置" label-width="156px" prop="courseList" class="classRecommend course-list">
          <div class="flex">
            <el-input v-model="searchCourse" placeholder="输入你想搜索的课程名称" style="width:200px;margin-right:20px" prefix-icon="el-icon-search" />
            <el-button type="primary" @click="searchCourseSubmit">查询</el-button>
            <el-button @click="resetCourse">重置</el-button>
          </div>
        </el-form-item>
        <el-table v-if="searchCourseList.length" ref="multipleTable3" size="small" :data="searchCourseList" style="width: 870px;margin-top:30px">
          <el-table-column prop="id" label="课程ID" fixed align="center" width="160px" />
          <el-table-column prop="name" label="课程标题" align="center" />
          <el-table-column fixed="right" label="操作" align="center">
            <template v-slot="{row}">
              <el-button size="small" type="text" class="link-color" @click="addCourse(row)">添加</el-button>
              <!-- <el-button v-if="!row.isChoose" size="small" type="text" class="link-color" @click="addCourse(row)">添加</el-button> -->
              <!-- <el-button v-else size="small" type="text">已添加</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <div v-if="curCourseList.length" class="addClassTitle">已添加课程</div>
        <el-table v-if="curCourseList.length" ref="multipleTable4" size="small" :data="curCourseList" style="width: 870px">
          <el-table-column prop="id" label="课程ID" fixed align="center" width="160px" />
          <el-table-column prop="name" label="课程标题" align="center" />
          <el-table-column fixed="right" label="操作" align="center">
            <template v-slot="{row, $index}">
              <el-button size="small" type="text" class="link-color" @click="removeCourse(row, $index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="flex course-banner">
          <el-form-item label-width="0" prop="courseBanner.imageUrl" class="image-config">
            <div class="flex uploadImg-cont">
              <UploadImage :show-replace="false" :disabled="disabled" :url="form.courseBanner.imageUrl" title="" save-path="running/" size-tips="1005px*503px" @triggerReg="handleCheckCourseBannerReg" @upload="data => (form.courseBanner.imageUrl = data)" />
            </div>
          </el-form-item>
          <div class="course-banner-link">
            <el-form-item label="链接地址" prop="courseBanner.linkUrl" style="width: 440px">
              <el-input v-model="form.courseBanner.linkUrl" placeholder="请输入课程Banner跳转链接" :disabled="disabled" />
            </el-form-item>
          </div>
        </div>
      </div>

      <div class="white-container marginTop">
        <el-form-item :label="form.type === 0 ? '跑步结果页推荐课程' : '骑行结果页推荐课程'" label-width="156px" prop="recommendedCourseId" class="classRecommend">
          <div class="flex">
            <el-input v-model="searchClass" placeholder="输入你想搜索的课程名称" style="width:200px;margin-right:20px" prefix-icon="el-icon-search" />
            <el-button type="primary" @click="searchClassSubmit">查询</el-button>
            <el-button @click="resetClass">重置</el-button>
          </div>
        </el-form-item>
        <el-table v-if="searchClassList.length" ref="multipleTable1" size="small" :data="searchClassList" style="width: 870px;margin-top:30px">
          <el-table-column prop="id" label="课程ID" fixed align="center" width="160px" />
          <el-table-column prop="name" label="课程标题" align="center" />
          <el-table-column fixed="right" label="操作" align="center">
            <template v-slot="{row}">
              <el-button v-if="!row.isChoose" size="small" type="text" class="link-color" @click="addClass(row)">添加</el-button>
              <el-button v-else size="small" type="text" class="link-color" @click="updateClass(row)">替换</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="classList.length" class="addClassTitle">已添加课程</div>
        <el-table v-if="classList.length" ref="multipleTable2" size="small" :data="classList" style="width: 870px">
          <el-table-column prop="id" label="课程ID" fixed align="center" width="160px" />
          <el-table-column prop="name" label="课程标题" align="center" />
          <el-table-column fixed="right" label="操作" align="center">
            <template v-slot="{row}">
              <el-button size="small" type="text" class="link-color" @click="removeClass(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="white-container marginTop">
        <RelatedProductsSetting ref="relatedProducts" :selected-products="selectedProducts" />
      </div>
      <div class="white-container marginTop">
        <el-form-item label="上传图片" prop="coverImage" class="image-config">
          <div class="flex uploadImg-cont">
            <!-- <UploadImage :disabled="disabled" :url="form.coverImage.activityListPagePicture" title="列表页图片" save-path="running/" size-tips="686px*240px" @triggerReg="handleCheckReg" @upload="data => (form.coverImage.activityListPagePicture = data)" /> -->
            <UploadImage :disabled="disabled" :url="form.coverImage.myActivityListPictures" title="我的运动列表页图片" save-path="running/" size-tips="360px*576px" @triggerReg="handleCheckReg" @upload="data => (form.coverImage.myActivityListPictures = data)" />
            <UploadImage :disabled="disabled" :url="form.coverImage.activityDetailsPageHeader" :title="form.type === 0 ? '跑步详情页头图' : '骑行详情页头图'" save-path="running/" size-tips="1125px*1125px" @triggerReg="handleCheckReg" @upload="data => (form.coverImage.activityDetailsPageHeader = data)" />
            <UploadImage :disabled="disabled" :url="form.coverImage.shareCardImage" title="小程序分享卡片" save-path="running/" :limit-size="2" size-tips="500px*400px" @triggerReg="handleCheckReg" @upload="data => (form.coverImage.shareCardImage = data)" />
            <UploadImage :disabled="disabled" :url="form.coverImage.shareImage" :title="form.type === 0 ? '跑步活动分享图片' : '骑行活动分享图片'" save-path="running/" size-tips="849px*849px" @triggerReg="handleCheckReg" @upload="data => (form.coverImage.shareImage = data)" />
            <UploadImage :disabled="disabled" :url="form.coverImage.bannerDiagramOfBottomCommunity" title="底部社群banner图" save-path="running/" size-tips="1005px*335px" @triggerReg="handleCheckReg" @upload="data => (form.coverImage.bannerDiagramOfBottomCommunity = data)" />
            <UploadImage :disabled="disabled" :url="form.coverImage.runningBackgroundImage" title="跑步背景图" save-path="running/" size-tips="750px*1624px" @triggerReg="handleCheckReg" @upload="data => (form.coverImage.runningBackgroundImage = data)" />
          </div>
        </el-form-item>
        <div class="flex btns">
          <el-button type="info" @click="cancel">取消</el-button>
          <el-button type="primary" @click="submit">保存</el-button>
        </div>
      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>
<script>
import { Running } from '@/model/Running';
import UploadImage from '@/components/UploadImage';
import Dialog from '@/components/Dialog';
import { uuid } from '@/common/js/uuid';
import RelatedProductsSetting from '@/components/RelatedProductsSetting';

export default {
  components: { UploadImage, Dialog, RelatedProductsSetting },
  data() {
    return {
      form: new Running(),
      rules: {
        type: [
          { required: true, message: "请选择报名方式", trigger: ["change"] },
        ],
        name: {
          required: true, validator: (rule, value, callback) => {
            const msg = this.form.type === 0 ? "请输入跑步标题" : "请输入骑行标题";
            if (!value) {
              callback(new Error(msg));
            } else {
              callback();
            }
          }, trigger: ['blur', 'change'],
        },

        exportTime: [
          { type: 'array', required: true, message: '请选择活动时间', trigger: ['change', 'blur'] },
        ],
        content: [
          { required: true, message: "请输入活动简介", trigger: ["blur"] },
        ],
        announcement: [
          { required: true, message: "请输入注意事项", trigger: ["blur"] },
        ],
        communityBanner: {
          linkUrl: [
            {
              required: true,
              validator: (rule, value, callback) => {
                const msg = "请输入社群Banner链接";
                if (!value) {
                  callback(new Error(msg));
                } else {
                  callback();
                }
              },
              trigger: ['blur'],
            },
          ],
        },
        isShow: [
          { required: true, message: "请选择是否在列表页展示", trigger: ["change"] },
        ],
        recommendedCourseId: [
          { type: 'array', required: true, message: "请选择课程", trigger: ["blur"] },
        ],
        prizePreviewChart: [
          { required: true, message: '请上传首页奖品图片', trigger: 'change' },
        ],
        coverImage: {
          required: true, validator: (rule, value, callback) => {
            const keys = [
              { key: 'myActivityListPictures', label: '我的运动列表页图片' },
              { key: 'activityDetailsPageHeader', label: '详情页头图' },
              { key: 'shareCardImage', label: '小程序分享卡片' },
              { key: 'shareImage', label: '活动分享图片' },
              { key: 'bannerDiagramOfBottomCommunity', label: '底部社群banner图' },
              // { key: 'activityListPagePicture', label: '列表页图片' },
              // { key: 'recommendedPcturesOfRelevantActivities', label: '相关活动推荐图片' },
            ];
            value.activityListPagePicture = ' ';
            // value.recommendedPcturesOfRelevantActivities = ' ';

            for (const { key, label } of keys) {
              if (!value[key]) {
                callback(new Error(`请上传${label}`));
              }
            }
            callback();
          }, trigger: ['change'],
        },
      },

      disabled: false,
      lottery: false,
      formDialogShow: false,
      information: {},
      searchClass: '',
      searchCourse: '',
      searchClassList: [],
      searchCourseList: [],
      classList: [],
      curCourseList: [],
      poolList: [],
      oriPoolList: [],
      selectedProducts: [],
    };
  },
  computed: {
  },
  watch: {
    "form.type": {
      deep: true,
      handler(newVal, oldVal) {
        this.$refs.form.clearValidate();
      },
    },
  },
  created() {
    const { query } = this.$route;
    this.lottery = query.lottery === 'true';
    if (query.id) {
      this.form.id = query.id;
      this.cancelTxt = "编辑";
      this.getDetails();
      this.remotePrizeMethod(query.id);
    } else {
      this.cancelTxt = "新增";
      this.remotePrizeMethod('');
    }
  },
  methods: {
    remotePrizeMethod(query) {
      this.$Api.newCamp.prizeSelectWithCurrent({ id: query }).then(data => {
        /* 每次要过滤掉已关联的 */
        data = data.map(item => {
          return {
            ...item,
            isSelected: false,
          };
        });
        this.poolList = data;
        if (this.form.prizeVOList && !query) {
          if (!this.oriPoolList.length) {
            this.oriPoolList = this.form.prizeVOList.map(item => {
              return {
                id: item.id,
                name: item.name,
                isSelected: true,
              };
            });
            this.oriPoolList = [...this.oriPoolList, ...data];
          }
          this.poolList = this.oriPoolList.filter(item => !item.isSelected);
        }
      });
    },
    handlePlanInputChange(e) {
      e.target.value = e.target.value.replace(/^(0+)|[^\d]+/g, '').replace(/\d{8,}/, (match) => match.slice(0, 8));
      if (!e.target.value) {
        // 阻止默认事件
        e.preventDefault();
      }
    },
    handlePrizeChange(poolId, item, index) {
      const target = this.oriPoolList.find(item => item.id === poolId);
      const oldItem = this.form.prizeVOList[index];
      this.form.prizeVOList[index] = { ...oldItem, ...target };
      this.form.prizeVOList = [...this.form.prizeVOList];
      const hasSelectedList = this.form.prizeVOList.map(item => item.id);
      this.oriPoolList = this.oriPoolList.map(item => {
        return {
          ...item,
          isSelected: !!hasSelectedList.includes(item.id),
        };
      });
      this.poolList = this.oriPoolList.filter(item => !item.isSelected);
      // item.prizeInformation.name = obj.name
      console.log(this.form.ridingDistance);
    },
    handlePrizeInputVisibleChange(isOpen) {
      !isOpen && this.remotePrizeMethod(this.form.id);
    },
    submit() {
      this.formDialogShow = true;
      const str = this.form.type === 0 ? '跑步' : '骑行';
      this.information = {
        operation: "submit",
        icon: "warn",
        subTitle: `请注意${str}活动状态，保存后已发布的${str}活动将实时更新至UA HOUSE小程序`,
      };
    },
    cancel() {
      this.formDialogShow = true;
      this.information = {
        operation: "cancel",
        icon: "warn",
        subTitle: `是否放弃${this.cancelTxt}，返回上级页面？`,
      };
    },
    getDetails() {
      this.$Api.running.detailRunningActivity(this.form.id).then((res) => {
        this.form = new Running(res);
        console.log('this.form', this.form);
        this.classList = this.form.recommendedCourseId;
        this.curCourseList = this.form.courseList;
        this.selectedProducts = res.equipmentSelectVO || [];
      });
    },
    dialogSuccess() {
      if (this.information.operation && this.information.operation === 'cancel') {
        this.$router.go(-1);
      } else if (this.information.operation && this.information.operation === 'submit') {
        this.$refs.form.validate(valid => {
          if (valid) {
            if (!this.multiDistanceValid(true)) return false;
            if (this.form.luckyDrawType === 0) {
              if (!this.prizeInformationValid(true)) return false;
            }
            this.form.ridingDistance.forEach(item => {
              if (!item.prizeInformation) {
                item.prizeInformation = {};
              }
              item.prizeInformation.goal = item.runningDistance;
            });
            if (this.form.id) {
              this.updateRunningActivity();
            } else {
              this.createRunningActivity();
            }
          } else {
            return false;
          }
        });
      }
    },
    createRunningActivity() {
      // this.form.formatForm();
      this.updateClassIdAndList();
      this.$Api.running.addRunningActivity(this.handleFormData()).then(() => {
        this.$message.success("保存成功");
        setTimeout(() => {
          this.$router.push('/online_activity/running');
        }, 2000);
      });
    },
    // 更新接口
    updateRunningActivity() {
      // this.form.formatForm();
      this.updateClassIdAndList();
      this.$Api.running.editRunningActivity(this.handleFormData()).then(() => {
        this.$message.success("编辑成功");
        setTimeout(() => {
          this.$router.push('/online_activity/running');
        }, 2000);
      });
    },
    searchClassSubmit() {
      if (!this.searchClass) return this.$message.warning("请先输入课程名称!");
      // 课程
      this.$Api.taskClock.taskCourseSelect(this.searchClass).then(res => {
        this.searchClassList = res.map(item => {
          return { ...item, isChoose: false };
        });
        if (this.classList && this.classList.length) {
          this.updateClassIdAndList();
        }
      });
    },
    searchCourseSubmit() {
      if (!this.searchCourse) return this.$message.warning("请先输入课程名称!");
      // 课程
      this.$Api.taskClock.taskCourseSelect(this.searchCourse).then(res => {
        this.searchCourseList = res.map(item => {
          return { ...item, isChoose: false };
        });
        if (this.curCourseList && this.curCourseList.length) {
          this.form.courseList = this.curCourseList.map((item) => { return item.id; });
          this.searchCourseList.forEach(item => {
            item.isChoose = false;
          });
        }
      });
    },
    handleFormData() {
      const data = { ...this.form };
      data.multiDistance = data.multiDistance.map(d => d.value);
      data.communityBanner = { ...data.communityBanner, imageUrl: data.coverImage.bannerDiagramOfBottomCommunity };
      if (typeof this.form.courseList[0] === 'object') {
        data.courseList = this.form.courseList.map(item => item.id);
      }
      const ref = this.$refs.relatedProducts;
      data.skus = ref.addList.map(item => item.productNo);
      return data;
    },
    addMultiDistance() {
      this.form.ridingDistance.push({
        id: uuid(),
        runningDistance: '',
        prizeInformation: {
          poolId: '',
          goal: '',
        },
      });
    },
    removeMultiDistance(id) {
      this.form.ridingDistance = this.form.ridingDistance.filter(d => d.id !== id);
    },
    resetClass() {
      this.searchClass = '';
      this.searchClassList = [];
    },
    resetCourse() {
      this.searchCourse = '';
      this.searchCourseList = [];
    },
    updateClass(row) {
      const item = this.searchClassList.find(item => item.id === row.id);
      if (item) {
        this.classList = [item];
        this.updateClassIdAndList();
      }
    },
    addClass(row) {
      const item = this.searchClassList.find(item => item.id === row.id);
      if (item) {
        this.classList.push(item);
        this.updateClassIdAndList();
        this.$refs.form.validateField('recommendedCourseId');
      }
    },
    addCourse(row) {
      const item = this.searchCourseList.find(item => item.id === row.id);
      if (item) {
        this.curCourseList.push(item);
        this.form.courseList = this.curCourseList.map((item) => { return item.id; });
        const cur = this.searchCourseList.find(ele => ele.id === item.id);
        cur.isChoose = true;
      }
    },
    removeClass(row) {
      const index = this.classList.findIndex(item => item.id === row.id);
      if (index !== -1) {
        const removedItem = this.classList.splice(index, 1)[0];
        this.updateClassIdAndList(removedItem.id);
      }
    },
    removeCourse(row, index) {
      this.curCourseList.splice(index, 1);
      this.form.courseList = this.curCourseList.map((item) => { return item.id; });
    },
    updateClassIdAndList(removedId = null) {
      this.form.recommendedCourseId = this.classList.map((item) => { return item.id; });
      this.searchClassList.forEach(item => {
        item.isChoose = removedId === null;
      });
    },
    handleCheckReg(val) {
      this.$refs.form.validateField("coverImage");
    },
    handleCheckChartReg(val) {
      this.$refs.form.validateField("prizePreviewChart");
    },
    handleCheckCourseBannerReg(val) {
      console.log(val);
    },
    // 新增奖品
    // addPrizeItem() {
    //   this.form.prizeInformationAddDTOList.push({
    //     prizeLevel: 1,
    //     prizeName: "",
    //     prizeNum: null,
    //   });
    // },
    farmatInput(index) {
      const value = this.form.ridingDistance[index].runningDistance;
      const regex = /^\d+(\.\d{0,2})?$/;
      if (regex.test(value)) {
        this.form.ridingDistance[index].runningDistance = value;
      } else {
        this.form.ridingDistance[index].runningDistance = parseFloat(value).toFixed(2);
      }
      this.multiDistanceValid();
    },
    multiDistanceValid(getValid) {
      console.log('验证');
      let valid = true;
      this.form.ridingDistance.forEach(item => {
        item.isError = item.runningDistance === 'NaN';
        if (getValid) {
          item.isError = item.runningDistance === '' || item.runningDistance === null || item.isError;
        }
        if (item.isError) {
          valid = false;
        }
      });
      return valid;
    },
    prizeInformationValid(getValid) {
      console.log('验证2');
      let valid = true;
      this.form.ridingDistance.forEach(item => {
        item.isErrorSelect = item.prizeInformation?.poolId === 'NaN';
        if (getValid) {
          item.isErrorSelect = item.prizeInformation?.poolId === '' || item.prizeInformation?.poolId === null || item.isError;
        }
        if (item.isErrorSelect) {
          valid = false;
        }
      });
      return valid;
    },
  },
};
</script>
<style lang="less" scoped>
.running-view {
  .marginTop {
    margin-top: 30px;
  }
  .btns {
    button {
      width: 120px;
      height: 50px;
    }
    align-items: center;
    justify-content: center;
  }
  :deep(.image-config) {
    .el-form-item__label {
      float: none;
    }
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .uploadImg-cont {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .uploader {
      margin-bottom: 30px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
  .classRecommend {
    display: flex;
    flex-direction: column;
    /deep/.el-form-item__content {
      margin-left: 8px !important;
      margin-top: 30px;
    }
  }
  .addClassTitle {
    color: #494949;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    margin: 50px 0 30px;
  }
  .delete-icon {
    margin-left: 8px;
    color: red;
    cursor: pointer;
  }
  .multi-distance-label {
    padding-right: 12px;
    width: 100px;
    text-align: right;
    line-height: 32px;
    &::before {
      content: '*';
      color: #F56C6C;
      margin-right: 4px;
    }
  }
  .add-multi-distance-btn {
    margin-left: 100px;
    margin-bottom: 30px;
  }
  .multi-distance-item {
    margin-bottom: 16px;
  }
  .course-banner {
    height: 273px;
    background-color: #F7F7F7;
    padding-left: 50px;
    padding-top: 30px;
    .course-banner-link {
      margin-top: 60px;
    }
    /deep/.el-upload {
      width: 387px;
      height: 194px;
    }
    /deep/.el-icon-plus {
      width: 387px;
      height: 194px;
      line-height: 194px;
    }
    /deep/.uploader-info {
      display: inline-block;
    }
  }
  .preview-banner {
    /deep/.uploader-info {
      display: inline-block;
    }
  }
  .course-list {
    /deep/.el-form-item__label {
      text-align: left;
    }
  }
  .multi-distance-error {
    margin-left: 100px;
  }
}
</style>
<style lang='less'>
</style>
